export default "__VITE_ASSET__CgeOgQfc__"